

export const userRoles = {
    ADMINS: "admins",
    SUPERADMINS: "superadmins",
    SUPERVISORS: "supervisors",
    ACCOUNTANT: "accountant",
    ALL: "All"
}

export const userstatus = {
    ACTIVE: "active",
    DISABLE: "disable",
    CONFIRMED: "confirmed",
    ALL: "all"
}
export const AlertType = {
    PROPERTY_CONFIRMED: "PROPERTY_CONFIRMED",
    FIRST_LOGIN: "FIRST_LOGIN",
    PROPERTY_REJECTED: "PROPERTY_REJECTED",
    PROPERTY_CHECKERAR: "PROPERTY_CHECKERAR",
    PROPERTY_CHECKEREN: "PROPERTY_CHECKEREN",
    PROPERTY_PUBLISHED: "PROPERTY_PUBLISHED"
}